import { LOGIN_DETAILS } from "../constants/action-types";

export const getLoginDetail = data => ({
  type: LOGIN_DETAILS,
  payload: data
});
